import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  view: string;
  icon?: React.ElementType;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  currentView: string;
  setCurrentView: (view: string) => void;
}
export function Breadcrumbs({
  items,
  currentView,
  setCurrentView
}: BreadcrumbsProps) {
  return <nav aria-label="Breadcrumb" data-id="element-2042">
      <ol className="flex items-center space-x-1" data-id="element-2043">
        {items.map((item, index) => <li key={index} className="inline-flex items-center" data-id="element-2044">
            {index > 0 && <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-2045" />}
            {index < items.length - 1 ? <button onClick={() => setCurrentView(item.view)} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800 transition-colors" data-id="element-2046">
                {item.icon && <item.icon className="w-4 h-4 mr-1.5" data-id="element-2047" />}
                {item.label}
              </button> : <span className="text-sm font-medium text-gray-900 flex items-center" data-id="element-2048">
                {item.icon && <item.icon className="w-4 h-4 mr-1.5" data-id="element-2049" />}
                {item.label}
              </span>}
          </li>)}
      </ol>
    </nav>;
}